module.exports = __webpack_public_path__ + "static/media/m1_sf_5.b819ca1c.png";